import React, { useEffect } from 'react'
import Meta from 'lib/meta'
import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { TabPanel, Tabs } from 'react-tabs'

import LegalLayout from 'components/commons/layouts/LegalLayout'
import { TermsSelector } from 'components/Pages/Terms/TermsSelector'

import styles from '../index.module.scss'

const UserSpaceTerms: NextPage<{ locale: string }> = ({ locale }) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.body.scrollTo({ top: 0, behavior: 'auto' })
    }
  }, [])

  const userTerms = [
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_0'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_0'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_1'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_1'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_2'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_2'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_3'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_3'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_4'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_4'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_5'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_5'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_6'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_6'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_7'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_7'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_8'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_8'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_9'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_9'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_10'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_10'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_11'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_11'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_12'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_12'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_13'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_13'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_14'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_14'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_15'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_15'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_16'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_16'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_17'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_17'),
    },
    {
      title: t('LEGAL.TERMS.USER.SECTION_TITLE_18'),
      description: t('LEGAL.TERMS.USER.SECTION_DESCRIPTION_18'),
    },
  ]

  return (
    <LegalLayout title={t('LEGAL.TERMS.TITLE')}>
      <Meta
        title={t('META.TITLE.TERMS_PAGE')}
        description={t('META.DESCRIPTION.TERMS_PAGE')}
        url={`/${locale === 'default' ? 'ja' : locale}`}
      />
      <div className={styles.wrap}>
        <TermsSelector type="space" />
        <Tabs className={styles.tabs} defaultIndex={0}>
          <TabPanel className={styles.tabPanel}>
            <>
              <p style={{ marginTop: 32 }} className={styles.sectionBoxDescription}>
                {t('LEGAL.TERMS.USER.DESCRIPTION')}
              </p>
              {userTerms.map((term, index) => (
                <section className={styles.sectionBox} key={index}>
                  <h3 className={styles.sectionBoxTitle}>{term.title}</h3>
                  <p className={styles.sectionBoxDescription}>{term.description}</p>
                </section>
              ))}
              <p className={styles.modification}>{t('LEGAL.TERMS.USER.MODIFICATION')}</p>
            </>
          </TabPanel>
        </Tabs>
      </div>
    </LegalLayout>
  )
}

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  }
}

export default UserSpaceTerms
